import React from 'react';
import styles from './CardListClipsModal.module.scss';
import Col from '../GridSystem/Col';
import Row from '../GridSystem/Row';
import Ref from '../Ref/Ref';
import { LoadingSpinner } from '../Icon/icons';
import CardRowWithClips from '../CardRowWithClips/CardRowWithClips';
import RecordNotFound from '../_empty_state/RecordNotFound';

const CardListClipsModal = ({ infiniteRef, loading, videos, searchInput, tags, isVideosEmpty }) => {
  return (
    <Col xs={12} className={styles.videoLibrary}>
      <Ref innerRef={infiniteRef}>
        <Row className={styles.row}>
          {(!loading || videos.length > 0) && !isVideosEmpty && (
            <>
              {videos.length > 0 ? (
                <div className={styles.cardsHeader}>
                  <div className={styles.title}>Title</div>
                  <div className={styles.owner}>Owner</div>
                  <div className={styles.created}>Created</div>
                </div>
              ) : null}
              {videos.map((video, index) => (
                <CardRowWithClips key={video.id} video={video} videoIndex={index} searchInput={searchInput} />
              ))}
            </>
          )}
          {loading && !isVideosEmpty && videos.length > 0 && (
            <div className={styles.spinnerContainer}>
              <LoadingSpinner theme="light" />
            </div>
          )}
          {videos?.length === 0 && (searchInput || tags?.length > 0) && !loading && (
            <div className={styles.emptyStateContainter}>
              <RecordNotFound searchTerm={searchInput} />
            </div>
          )}
        </Row>
      </Ref>
    </Col>
  );
};

export default CardListClipsModal;
